import { LiveUrlAudioPlaybackProvider } from '@app/core/playback/audio/LiveUrlAudioPlaybackProvider';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { get } from 'lodash';
import { PlayLive } from './PlayLive';

export function StationPlayLive() {
  const station = useActiveStation();
  const liveStreamUrl = get(station, 'streams.0.url');

  if (!liveStreamUrl) {
    return null;
  }

  return (
    <LiveUrlAudioPlaybackProvider src={liveStreamUrl} playbackId={`live-audio--${station.slug}`}>
      <PlayLive />
    </LiveUrlAudioPlaybackProvider>
  );
}
